import React from 'react';

type BadgeVariant =
  | 'critical' |'high' |'medium' |'low' |'open' |'closed' |'in-progress' |'pending' |'approved' |'draft' |'recordable' |'non-recordable' |'overdue';

const variantStyles: Record<BadgeVariant, string> = {
  critical: 'bg-red-500/15 text-red-500 border-red-500/20',
  high: 'bg-orange-500/15 text-orange-500 border-orange-500/20',
  medium: 'bg-amber-500/15 text-amber-500 border-amber-500/20',
  low: 'bg-emerald-500/15 text-emerald-500 border-emerald-500/20',
  open: 'bg-blue-500/15 text-blue-500 border-blue-500/20',
  closed: 'bg-zinc-500/15 text-zinc-400 border-zinc-500/20',
  'in-progress': 'bg-violet-500/15 text-violet-500 border-violet-500/20',
  pending: 'bg-amber-500/15 text-amber-500 border-amber-500/20',
  approved: 'bg-emerald-500/15 text-emerald-500 border-emerald-500/20',
  draft: 'bg-zinc-500/15 text-zinc-400 border-zinc-500/20',
  recordable: 'bg-red-500/15 text-red-500 border-red-500/20',
  'non-recordable': 'bg-zinc-500/15 text-zinc-400 border-zinc-500/20',
  overdue: 'bg-red-600/15 text-red-600 border-red-600/20',
};

interface StatusBadgeProps {
  variant: BadgeVariant;
  label: string;
  className?: string;
}

export default function StatusBadge({ variant, label, className = '' }: StatusBadgeProps) {
  return (
    <span
      className={`
        inline-flex items-center px-2 py-0.5 rounded-md text-[11px] font-600 border tabular-nums
        ${variantStyles[variant]} ${className}
      `}
    >
      {label}
    </span>
  );
}